"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnchorManual = exports.isAnchorP2P = exports.isAnchorLocationGPS = exports.isFileData = exports.isCaptureData = exports.isLink = exports.isHeightProviderManual = exports.isHeightPhotomeasureManualProvider = exports.isHeightPhotomeasureProvider = exports.isHeightSpanHeightProvider = exports.isVectorProviderManual = exports.isVectorCollectionProvider = exports.isVectorPointToPointProvider = exports.isVerticalSeparationDrawable = exports.isMaskDrawable = exports.isLineDrawable = exports.isMarkerDrawable = exports.isHiddenImageVisibility = exports.isGammaBrightnessCorrection = exports.isFreeCropParameter = void 0;
exports.findObjectsWhere = findObjectsWhere;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var isFreeCropParameter = function (o) { return o.tag === 'free'; };
exports.isFreeCropParameter = isFreeCropParameter;
var isGammaBrightnessCorrection = function (o) { return o.tag === 'gamma'; };
exports.isGammaBrightnessCorrection = isGammaBrightnessCorrection;
var isHiddenImageVisibility = function (o) { return o.tag === 'hidden'; };
exports.isHiddenImageVisibility = isHiddenImageVisibility;
var isMarkerDrawable = function (o) { return o.tag === core_api_1.DrawableTag.MARKER || o.tag === core_api_1.DrawableTag.OFFSET; };
exports.isMarkerDrawable = isMarkerDrawable;
var isLineDrawable = function (o) { return o.tag === core_api_1.DrawableTag.LINE; };
exports.isLineDrawable = isLineDrawable;
var isMaskDrawable = function (o) { return o.tag === core_api_1.DrawableTag.MASK; };
exports.isMaskDrawable = isMaskDrawable;
var isVerticalSeparationDrawable = function (o) { return o.tag === core_api_1.DrawableTag.VERTICAL_SEPARATION; };
exports.isVerticalSeparationDrawable = isVerticalSeparationDrawable;
var isVectorPointToPointProvider = function (fieldData) { return fieldData.provider === 'pointtopoint'; };
exports.isVectorPointToPointProvider = isVectorPointToPointProvider;
var isVectorCollectionProvider = function (fieldData) { return fieldData.provider === 'collection'; };
exports.isVectorCollectionProvider = isVectorCollectionProvider;
var isVectorProviderManual = function (fieldData) { return fieldData.provider === 'manual'; };
exports.isVectorProviderManual = isVectorProviderManual;
var isHeightSpanHeightProvider = function (fieldData) { return fieldData.provider === 'spanheight'; };
exports.isHeightSpanHeightProvider = isHeightSpanHeightProvider;
var isHeightPhotomeasureProvider = function (fieldData) { return fieldData.provider === 'photomeasure'; };
exports.isHeightPhotomeasureProvider = isHeightPhotomeasureProvider;
var isHeightPhotomeasureManualProvider = function (fieldData) { return fieldData.provider === 'photomeasuremanual'; };
exports.isHeightPhotomeasureManualProvider = isHeightPhotomeasureManualProvider;
var isHeightProviderManual = function (fieldData) { return fieldData.provider === 'manual'; };
exports.isHeightProviderManual = isHeightProviderManual;
var isLink = function (fieldData) { return fieldData.provider === 'collection'; };
exports.isLink = isLink;
var isCaptureData = function (object) { return object.camera != null && object.camera.imageuuid != null; };
exports.isCaptureData = isCaptureData;
var isFileData = function (object) { return object.attachmentId != null && object.size != null; };
exports.isFileData = isFileData;
var isAnchorLocationGPS = function (object) { return object.value.collectionTool === 'LOCATION' && object.provider === 'gps'; };
exports.isAnchorLocationGPS = isAnchorLocationGPS;
var isAnchorP2P = function (object) { return object.value.collectionTool === 'VECTOR' && object.provider === 'pointtopoint'; };
exports.isAnchorP2P = isAnchorP2P;
var isAnchorManual = function (object) { return object.value.collectionTool === 'VECTOR' && object.provider === 'manual'; };
exports.isAnchorManual = isAnchorManual;
function findObjectsWhere(data, pred) {
    var e_1, _a;
    if (pred(data)) {
        return [data];
    }
    var found = [];
    try {
        for (var _b = tslib_1.__values(Object.keys(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = data[key];
            if (value && typeof value === 'object') {
                found = found.concat(findObjectsWhere(value, pred));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return found;
}
//# sourceMappingURL=collection.model.util.js.map